import React, { useState } from 'react';
import axios from 'axios';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import httpClient from '../../_util/api';
import { Button } from '@mui/material';
import './style.scss';

const DownloadExcel = (props) => {
    const [downloadExcelClicked, setDownloadexcelClicked] = useState(false)

    const handleDownload = async () => {
        try {

            const data = props.data;

            // Function to convert camelCase to 'Title Case' with spaces
            const formatHeader = (header) => {
                return header.replace(/([a-z])([A-Z])/g, '$1 $2')  // Add space between camelCase
                    .replace(/^./, str => str.toUpperCase()); // Capitalize first letter
            };

            // Extract the keys from the first object in your data to use as headers
            const keys = Object.keys(data[0]); // Assuming data is an array of objects

            // Generate formatted headers
            const formattedHeaders = keys.map(key => formatHeader(key));


            // Convert the JSON data to a worksheet
            const worksheet = XLSX.utils.json_to_sheet(data);
            console.log("worksheet", worksheet)

            // Insert the custom formatted headers
            const range = XLSX.utils.decode_range(worksheet['!ref']);
            for (let i = 0; i < formattedHeaders.length; i++) {
                const cell = XLSX.utils.encode_cell({ r: 0, c: i }); // First row, i-th column
                worksheet[cell] = {
                    v: formattedHeaders[i],
                    s: { font: { bold: true }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FFFF00" } } }
                };
            }

            // Update the range to ensure the header row is counted
            range.e.r = Math.max(range.e.r, 1);
            worksheet['!ref'] = XLSX.utils.encode_range(range);

            // Create a new workbook and append the worksheet
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

            // Generate a buffer from the workbook
            const excelBuffer = XLSX.write(workbook, {
                bookType: 'xlsx',
                type: 'array',
            });

            // Create a Blob from the buffer and trigger a download
            const blob = new Blob([excelBuffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
            });
            saveAs(blob, 'Students Data.xlsx');

        } catch (error) {
            console.error('Failed to download the Excel file:', error);
        }
    };

    return (
        <Button variant="contained" className='button' sx={{ backgroundColor: '#208146' }}
            onClick={handleDownload}
        >Download Excel</Button>
    );
};

export default DownloadExcel;
